import { Cloud, ShoppingBag } from 'lucide-react';
import type { IntegrationType } from '@/shared/types/nps';

/** Identidade de marca de cada provider (cores oficiais aproximadas). */
const BRAND: Record<IntegrationType, { bg: string; glow: string }> = {
  NUVEMSHOP: { bg: 'linear-gradient(135deg,#2CC5D2 0%,#2D6CDF 100%)', glow: '45,108,223' },
  WOOCOMMERCE: { bg: 'linear-gradient(135deg,#A05CC9 0%,#7F54B3 100%)', glow: '127,84,179' },
  SHOPIFY: { bg: 'linear-gradient(135deg,#9BCB52 0%,#5E8E3E 100%)', glow: '94,142,62' },
  WBUY: { bg: 'linear-gradient(135deg,#3B82F6 0%,#1D4ED8 100%)', glow: '37,99,235' },
};

function Glyph({ type, size }: { type: IntegrationType; size: number }) {
  const px = Math.round(size * 0.5);
  if (type === 'SHOPIFY') return <ShoppingBag style={{ width: px, height: px }} strokeWidth={2.2} />;
  if (type === 'NUVEMSHOP') return <Cloud style={{ width: px, height: px }} strokeWidth={2.2} />;
  if (type === 'WOOCOMMERCE')
    return <span style={{ fontSize: size * 0.32 }} className="font-bold lowercase italic tracking-tighter">woo</span>;
  return <span style={{ fontSize: size * 0.42 }} className="font-extrabold tracking-tight">W</span>;
}

export function ProviderLogo({ type, size = 48 }: { type: IntegrationType; size?: number }) {
  const brand = BRAND[type];
  return (
    <span
      className="grid shrink-0 place-items-center rounded-2xl text-white"
      style={{
        width: size,
        height: size,
        background: brand.bg,
        boxShadow: `0 8px 20px -6px rgba(${brand.glow},0.55)`,
      }}
    >
      <Glyph type={type} size={size} />
    </span>
  );
}
